// src/utils/cn.js - Class Name Utility
import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Utility function to merge Tailwind CSS classes
 * Combines clsx for conditional classes and tailwind-merge for proper Tailwind class merging
 * 
 * @param {...any} inputs - Class names to merge
 * @returns {string} - Merged class names
 * 
 * @example
 * cn('px-4 py-2', isActive && 'bg-blue-500', className)
 * cn('text-red-500', 'text-blue-500') // Returns 'text-blue-500' (latter wins)
 */
export function cn(...inputs) {
  return twMerge(clsx(inputs));
}